import { render, staticRenderFns } from "./DetailInstantQuotation.vue?vue&type=template&id=62738b75&lang=html&"
import script from "./DetailInstantQuotation.vue?vue&type=script&lang=js&"
export * from "./DetailInstantQuotation.vue?vue&type=script&lang=js&"
import style0 from "./DetailInstantQuotation.vue?vue&type=style&index=0&id=62738b75&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports